module.exports = __webpack_public_path__ + "img/copy_outline_24.a6fa4ef6.svg";